import AddressSummary from './AddressSummary'

export default {
  components: {
    AddressSummary,
  },

  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Business">
      <ui-form-item label="Business Name">
        {{ model.business.name }}
      </ui-form-item>

      <br>
      <ui-form-item label="Service Address">
        <address-summary :address="model.business.serviceAddress" />
      </ui-form-item>
      
      <br>
      <ui-form-item label="Federal ID# or Social Security Number">
        {{ model.business.federalId }}
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },
}
